import { ref, computed } from 'vue'

// Singleton state
const isOpen = ref(false)
const isMinimized = ref(false)

export function useTasksWidget() {
  function open() {
    isOpen.value = true
    isMinimized.value = false
  }

  function close() {
    isOpen.value = false
    isMinimized.value = false
  }

  function minimize() {
    isOpen.value = false
    isMinimized.value = true
  }

  function restore() {
    isOpen.value = true
    isMinimized.value = false
  }

  function toggle() {
    if (isOpen.value) {
      close()
    } else {
      open()
    }
  }

  return {
    isOpen: computed(() => isOpen.value),
    isMinimized: computed(() => isMinimized.value),
    open,
    close,
    minimize,
    restore,
    toggle,
  }
}
